import React from "react";

export default function DeleteProfileCardShimmer() {
  
  return (
    <div>
      <div class="sprint16-myacc-cards2 mt-4 shimmer-effect">
        <div class="sprint16-myacc-card02">
          <div class="s16-card01-left w-100">
            <div class="s16-card01-cont w-100">
              <h5 className="shimmerBG shimmer-h25 m-0 w-50"></h5>
             
              <p className="shimmerBG shimmer-h15 m-0 w-100 mt-1" ></p>
              <p className="shimmerBG shimmer-h15 m-0 w-25"  ></p>
              
            </div>
          </div>
          <div class="">
            <button class="custom_btn  shimmetrBG shimmer-button-md btn_block sp16_custom_btn">
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
